import { Navigate } from 'react-router-dom';
import HomePage from '../pages/Home/HomePage';
import AlertsPage from '../pages/Alerts/AlertsPage';
import DriversPage from '../pages/Drivers/DriversPage';
import VehiclesPage from '../pages/Vehicles/VehiclesPage';
import DevicesPage from '../pages/Devices/DevicesPage';
import AlertDetailsPage from '../pages/AlertDetails/AlertDetails';
import DriverDetailsPage from '../pages/DriverDetails/DriverDetails';
import VehicleDetailsPage from '../pages/VehicleDetails/VehicleDetails';
import DeviceDetailsPage from '../pages/DeviceDetails/DeviceDetails';
import VideosPage from '../pages/Videos/VideosPage';
import VideoDetailsPage from '../pages/VideoDetails/VideoDetails';
import TripsPage from '../pages/Trips/TripsPage';
import TripDetailsPage from '../pages/TripDetails/TripDetails';
// import UsersPage from '../pages/Users/UsersPage';
import UsersManagement from '../pages/UserManagement/UserManagement';
import GeofencesPage from '../pages/Geofences/GeofencesPage';
import SearchPage from '../pages/Search/SearchPage';
import SettingsPage from '../pages/Settings/SettingsPage';
import AssignAnnouncementPage from '../pages/Settings/AssignAnnouncement/AssignAnnouncementPage';
import AnnouncementPage from '../pages/Announcement/AnnouncementPage';
import Health from '../pages/Health/HealthPage';

const routesConfig = [
  { path: '/home', element: <HomePage /> },
  { path: '/alerts', element: <AlertsPage /> },
  {
    path: '/alerts/:id',
    element: <AlertDetailsPage />,
  },
  { path: '/vehicles', element: <VehiclesPage /> },
  { path: '/vehicles/:id', element: <VehicleDetailsPage /> },
  { path: '/drivers', element: <DriversPage /> },
  { path: '/drivers/:id', element: <DriverDetailsPage /> },
  { path: '/devices', element: <DevicesPage /> },
  { path: '/devices/:id', element: <DeviceDetailsPage /> },
  { path: '/videos', element: <VideosPage /> },
  { path: '/videos/:id', element: <VideoDetailsPage /> },
  { path: '/trips', element: <TripsPage /> },
  { path: '/trips/:id', element: <TripDetailsPage /> },
  { path: '/management', element: <UsersManagement /> },
  { path: '/geofences', element: <GeofencesPage /> },
  { path: '/health', element: <Health /> },
  { path: '/search', element: <SearchPage /> },
  { path: '/announcements', element: <AnnouncementPage /> },
  { path: '/announcements/assign', element: <AssignAnnouncementPage /> },
  { path: '/settings', element: <SettingsPage /> },
  { path: '*', element: <Navigate to="/home" replace /> },
];

export default routesConfig;
